// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1BXVJ","colMin":"styles_colMin__tuzqQ","colCheckbox":"styles_colCheckbox__VPy_G"};